enum ToggleVariant
{
    Primary = "Primary",
    Secondary = "Secondary",
    Success = "Success",
    Warning = "Warning",
    Danger = "Danger"
};

export const ToggleVariantValuesMap = {
    [ToggleVariant.Primary]: "primary",
    [ToggleVariant.Secondary]: "secondary",
    [ToggleVariant.Success]: "success",
    [ToggleVariant.Warning]: "warning",
    [ToggleVariant.Danger]: "danger"
};

enum ToggleSize {
    XSmall = "Xsmall",
    Small = "Small",
    Medium = "Medium",
    Large = "Large"
}

export const ToggleSizeValuesMap = {
    [ToggleSize.XSmall]: "xsmall",
    [ToggleSize.Small]: "small",
    [ToggleSize.Medium]: "medium",
    [ToggleSize.Large]: "large"
};

export { ToggleVariant, ToggleSize }